import { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PrivateRoute from "../utils/PrivateRoute";
import { PageLoader } from "../components/organisms/PageLoader/PageLoader";
import DashboardTemplate from "../components/templates/dashboard/DashboardTemplate";
import DashboardTest from "../pages/dashboard/DashboardTest";

const Setting = lazy(() => import("../pages/setting/Setting"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Trade = lazy(() => import("../pages/Trade/Trade/Trade"));
const DesktopTrade = lazy(
  () => import("../pages/Trade/DesktopTrade/DesktopTrade")
);
const BuyCrypto = lazy(() => import("../pages/Trade/BuyCrypto/BuyCrypto"));
const TradeHistory = lazy(
  () => import("../pages/Trade/TradeHistory/TradeHistory")
);
const Market = lazy(() => import("../pages/market/Market"));
const Profile = lazy(() => import("../pages/setting/profile/Profile"));
const EasyTrade = lazy(() => import("../pages/Trade/EasyTrade/index"));
const UserCreditCards = lazy(
  () => import("../pages/setting/banking/UserCreditCards")
);
const AddCreditCard = lazy(
  () => import("../pages/setting/banking/AddCreditCard")
);
const LoginHistory = lazy(
  () => import("../pages/setting/login-history/LoginHistory")
);
const NewsList = lazy(() => import("../pages/news/NewsList"));
const SingleNews = lazy(() => import("../pages/news/SingleNews"));
const Portfolio = lazy(() => import("../pages/portfolio/Portfolio"));
const Transfer = lazy(() => import("../pages/transfer/Transfer"));
const QrCodeImage = lazy(() => import("../pages/transfer/QrCodeImage"));
const KYC = lazy(() => import("../pages/kyc/Kyc"));
const Notification = lazy(() => import("../pages/notification/Notification"));
const SingleWallet = lazy(() => import("../pages/wallet/SingleWallet"));
const InviteUser = lazy(() => import("../pages/user/Invite"));
const ChangePass = lazy(() => import("../pages/setting/ChangePass"));
const WithdrawIrt = lazy(() => import("../pages/wallet/WithdrawIrt"));
const OTCTether = lazy(() => import("../pages/otcTether/OTCTether"));
const Login = lazy(() => import("../pages/Auth/Login/Login"));
const CoinWithdraw = lazy(() => import("../pages/coinWithdraw"));
const CollateralPage = lazy(() => import("../pages/collateral"));
const ReferralPage = lazy(() => import("../pages/referral"));

const Routes = () => (
  <Switch>
    <Suspense fallback={<PageLoader></PageLoader>}>
      <Route exact path="/buy-sell/tether" component={OTCTether} />
      <Route
        exact
        path={[
          "/",
          "/dashboard",
          "/dashboard-test",
          "/trade",
          "/crypto/trade",
          "/crypto/trade/history",
          "/crypto/trade/buy",
          "/markets",
          "/setting",
          "/setting/profile",
          "/crypto/trade/easy",
          "/setting/credits",
          "/setting/changePass",
          "/setting/credits/add",
          "/setting/login-history",
          "/news",
          "/news/:id",
          "/user/portfolio",
          "/transfer",
          "/wallet/qr/view",
          "/kyc",
          "/notification",
          "/user/wallet/:coin",
          "/user/withdrawIrt",
          "/coin/withdraw",
          "/collateral",
          "/referral",
          // '/user/invite',
        ]}
      >
        <DashboardTemplate>
          <PrivateRoute exact path="/" component={Dashboard} />
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute
            exact
            path="/dashboard-test"
            component={DashboardTest}
          />
          <PrivateRoute exact path="/crypto/trade" component={Trade} />
          <PrivateRoute
            exact
            path="/crypto/trade/history"
            component={TradeHistory}
          />
          <PrivateRoute exact path="/markets" component={Market} />
          <PrivateRoute exact path="/setting" component={Setting} />
          <PrivateRoute exact path="/setting/profile" component={Profile} />
          <PrivateRoute exact path="/crypto/trade/easy" component={EasyTrade} />
          <PrivateRoute
            exact
            path="/setting/credits"
            component={UserCreditCards}
          />
          <PrivateRoute
            exact
            path="/setting/changePass"
            component={ChangePass}
          />
          <PrivateRoute
            exact
            path="/setting/credits/add"
            component={AddCreditCard}
          />
          <PrivateRoute
            exact
            path="/setting/login-history"
            component={LoginHistory}
          />
          <PrivateRoute exact path="/news" component={NewsList} />
          <PrivateRoute exact path="/news/:id" component={SingleNews} />
          <PrivateRoute exact path="/user/portfolio" component={Portfolio} />
          {/*TODO: remove deprecated routes and pages*/}
          {/*<PrivateRoute exact path="/transfer" component={Transfer} />*/}
          <PrivateRoute exact path="/wallet/qr/view" component={QrCodeImage} />
          <PrivateRoute exact path="/kyc" component={KYC} />
          <PrivateRoute exact path="/notification" component={Notification} />
          {/*TODO: remove deprecated routes and pages*/}
          {/*<PrivateRoute*/}
          {/*  exact*/}
          {/*  path="/user/wallet/:coin"*/}
          {/*  component={SingleWallet}*/}
          {/*/>*/}
          <PrivateRoute
            exact
            path="/user/withdrawIrt"
            component={WithdrawIrt}
          />
          {/* <PrivateRoute exact path="/user/invite" component={InviteUser} /> */}
          <PrivateRoute exact path="/trade" component={DesktopTrade} />
          <PrivateRoute exact path="/crypto/trade/buy" component={BuyCrypto} />
          <PrivateRoute
            component={CoinWithdraw}
            path={"/coin/withdraw"}
            exact
          />
          <PrivateRoute component={CollateralPage} path={"/collateral"} exact />
          <PrivateRoute component={ReferralPage} path={"/referral"} exact />
        </DashboardTemplate>
      </Route>
      <PrivateRoute exact path="/login" component={Login} />
    </Suspense>
  </Switch>
);

export default Routes;
